import React, { useContext } from 'react'

import { FileState } from 'ui/components/FileUpload/types'

export type FileUploadContextValue = {
    files: FileState[]
    isDraggingOver: boolean
    urlCache: WeakMap<File, string>
    inputRef: React.RefObject<HTMLInputElement>
    dropzoneId: string
    inputId: string
    listId: string
    labelId: string
    dispatch: React.Dispatch<FileUploadAction>
    disabled?: boolean
    accept?: string
    maxFiles?: number
    maxSize?: number
    multiple?: boolean
    name?: string
    required?: boolean
    onFilesChange: (files: File[]) => void
}

export type FileUploadAction =
    | { type: 'ADD_FILES'; files: File[] }
    | { type: 'SET_FILES'; files: File[] }
    | { type: 'SET_PROGRESS'; file: File; progress: number }
    | { type: 'SET_SUCCESS'; file: File }
    | { type: 'SET_ERROR'; file: File; error: string }
    | { type: 'REMOVE_FILE'; file: File }
    | { type: 'SET_IS_DRAGGING_OVER'; isDraggingOver: boolean }
    | { type: 'CLEAR' }

export const FileUploadContext = React.createContext<FileUploadContextValue | null>(null)

export function useFileUploadContext(): FileUploadContextValue {
    const context = useContext(FileUploadContext)

    if (!context) {
        throw new Error('useFileUploadContext must be used within a FileUploadContextProvider')
    }

    return context
}
